import { Stack, Pagination } from "@mui/material";

export function TablePagination({  count, 
  pagePendentes, 
  pageFinalizadas, 
  activeTab, 
  setPagePendentes, 
  setPageFinalizadas  }) {
  return (
    <Stack spacing={1}>
      <Pagination
        count={count}
        page={activeTab === "Pendentes" ? pagePendentes : pageFinalizadas}
        onChange={(_, value) => activeTab === "Pendentes" ? setPagePendentes(value)
      : setPageFinalizadas(value)}
        size="small"
      />
    </Stack>
  );
}
